import { types, getParent } from 'mobx-state-tree'

export const Part = types
  .model({
    name: '',
    materialId: types.maybe(types.string),
    materialDescription: '',
    materialUnits: types.optional(types.enumeration(['each', 'metre', 'sheet']), 'each'),
    materialStockLength: types.maybe(types.number),
    materialSheetSizeX: types.maybe(types.number),
    materialSheetSizeY: types.maybe(types.number),
    materialUnitCost: types.optional(types.number, 0),
    qty : 1,
    cutLength: types.maybe(types.number),
    cutWidth: types.maybe(types.number),
    comment: ''
  })
  .actions(self => ({
    setName(name) {
      self.name = name
    },
    setMaterialId(id) {
      self.materialId = id
    },
    setMaterialDescription(description) {
      self.materialDescription = description
    },
    setMaterialUnits(units) {
      self.materialUnits = units
      if (units === 'metre') self.cutWidth = null
      if (units === 'each') {
        self.cutLength = null
        self.cutWidth = null
      }
    },
    setMaterialStockLength(length) {
      self.materialStockLength = length
    },
    setMaterialSheetSizeX(x) {
      self.materialSheetSizeX = x
    },
    setMaterialSheetSizeY(y) {
      self.materialSheetSizeY = y
    },
    setMaterialSheetSize(x, y) {
      self.materialSheetSizeX = x
      self.materialSheetSizeY = y
    },
    setMaterialUnitCost(cost) {
      self.materialUnitCost = cost
    },
    setQty(qty) {
      self.qty = qty
    },
    setCutLength(length) {
      self.cutLength = length
    },
    setCutWidth(width) {
      self.cutWidth = width
    },
    setComment(comment) {
      self.comment = comment
    },
    remove() {
      getParent(self, 2).removeItem(self)
    }
  })).views(self => ({
    get isValid() {
      if (self.materialUnits === 'metre') {
        if (!(self.cutLength > 0)) return false
      }
      if (self.materialUnits === 'sheet') {
        if (!(self.cutLength > 0)) return false
        if (!(self.cutWidth > 0)) return false
      }
      if (self.materialStockLength > 99) return false
      if (self.materialSheetSizeX > 99 || self.materialSheetSizeY > 99) return false
      return ((self.qty > 0) && ((self.name.length > 0) || (self.materialDescription.length > 0)))
    }
  }))


// WEBPACK FOOTER //
// ./src/models/Part.js